import { Dispatch, SetStateAction, useEffect } from 'react';

export type FeatureFlagsPreviewState<T> = { key: string; value?: T; error?: string } | null;

export const useFeatureFlagsPreview = <T>(
    requestKey: string,
    refresh: number,
    load: () => Promise<T>,
    onPreview: Dispatch<SetStateAction<FeatureFlagsPreviewState<T>>>
) => {
    useEffect(() => {
        let current = true;
        onPreview(null);
        const timeout = setTimeout(
            () =>
                load().then(
                    value => current && onPreview({ key: requestKey, value }),
                    error =>
                        current &&
                        onPreview({
                            key: requestKey,
                            error: error instanceof Error ? error.message : 'Unable to determine processing choices.'
                        })
                ),
            400
        );
        return () => {
            current = false;
            clearTimeout(timeout);
        };
    }, [requestKey, refresh, load, onPreview]);
};
